import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  reimbsList: [], 
  reimbArr: [],
  reimbArray: [],
  reimbID: '',
  reimbBalance: '',
  selectedReimb: null,
  selectedEmployee: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.reimbsList = [];
    state.reimbArr = [];
    state.reimbArray = [];
    state.reimbID = "";
    state.reimbBalance = "";
    state.selectedReimb = null;
    state.selectedEmployee = null;
    state.isEditing = false;
  },
  SET_SELECTED_REIMB(state, reimb) {
    state.selectedReimb = reimb;
    state.isEditing = true;
  },
  LIST_REIMBS(state, reimbs) {
    state.reimbsList = reimbs;
  },
  REIMBS_ARRAY(state, reimbs){
    state.reimbArray = reimbs;
  },
  SET_SELECTED_EMPLOYEE(state, employee) {
    state.selectedEmployee = employee;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){

    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createReimbursement({ commit,state }, formData) {
    return axios.post('api/v1/create-reimbursement/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  fetchReimbursements({ commit,state }, formData) {
    state.reimbArr = [];
    axios.post(`api/v1/get-reimbursements/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.reimbArr.push((response.data[i].employee.employee_name + " - " + response.data[i].month + "/" + response.data[i].year));
      }
      commit('LIST_REIMBS', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchReimbursement({ commit,state }, formData) {
    axios.post(`api/v1/get-reimbursements/`,formData)
    .then((response)=>{
      state.selectedReimb = response.data;
      const selectedEmployee = response.data.employee.staff_number + " - " + response.data.employee.employee_name;
      commit('SET_SELECTED_REIMB',response.data);
      commit('SET_SELECTED_EMPLOYEE', selectedEmployee);

    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedReimbursement({ commit, state }, option){
    const selectedReimb = state.reimbsList.find(reimb => (reimb.employee.employee_name + " - " + reimb.month + "/" + reimb.year) === option);
    if (selectedReimb) {
        state.reimbID = selectedReimb.reimbursement_id;
        state.reimbArray = [...state.reimbArray, selectedReimb];
    }
    commit('REIMBS_ARRAY', state.reimbArray);
      
  },

  async updateReimbursement({ commit,state }, formData) {
    return axios.put(`api/v1/update-reimbursement/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteReimbursement({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Reimbursement?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Reimbursement!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-reimbursement/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Reimbursement removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Reimbursement",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Reimbursement has not been deleted!`);
      }
    })
  },

};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  